export const MAX_COLUMN_WIDTH = 400